import Alpine from "alpinejs";

export const uiTheme = {
  _validThemes: ["light", "dark", "system"],

  init() {
    Alpine.effect(() => {
      // Accessing the value here creates a dependency on userPreferences
      const currentTheme = Alpine.store("userPreferences").theme || "system";

      this._applyTheme(currentTheme);
    });

    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", () => {
        const currentTheme = Alpine.store("userPreferences").theme || "system";
        if (currentTheme === "system") {
          this._applyTheme("system");
        }
      });
  },

  _applyTheme(theme) {
    let resolvedTheme = theme;

    if (theme === "system") {
      resolvedTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }

    // Set the Bootstrap attribute
    document.documentElement.setAttribute("data-bs-theme", resolvedTheme);

    // Optional: Update standard body classes if needed
    document.body.classList.toggle("dark-mode", resolvedTheme === "dark");
  },
};
